/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    callback
  );

export const createLandClassification = (payload, callback) =>
  req.create(
    c.CREATE_LAND_CLASSIFICATION,
    'api/v1/rpt/administrator/land/settings/land_classifications',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandClassification = (id, payload, callback) =>
  req.update(
    c.UPDATE_LAND_CLASSIFICATION,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandClassification = (id, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_CLASSIFICATION,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const createLandSubClass = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_SUB_CLASS ,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classifications`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandSubClass = (id, classificationId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_CLASSIFICATION,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classifications/${classificationId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const removeLandSubClass = (id, classificationId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_SUB_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classifications/${classificationId}`,
    payload,
    callback
  );

export const createLandSubItem = (payload, callback) =>
  req.create(
    c.CREATE_LAND_SUB_ITEM ,
    `api/v1/rpt/administrator/land/settings/land_classifications/${payload.id}/land_sub_classification_items`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandSubItem = (id, subClassId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_SUB_ITEM,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classification_items/${subClassId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const removeLandSubItem = (id, subClassId, callback) =>
  req.remove(
    c.REMOVE_LAND_SUB_ITEM,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classification_items/${subClassId}`,
    () => {
      if (callback) callback();
    }
  );

  export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

  export const getSubClassificationsList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_SUB_CLASSIFICATIONS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classifications`,
    payload,
    callback
  );

  export const getSubClassificationsItemsList = (id, callback) =>
    req.list(
      c.GET_LAND_SUB_CLASSIFICATIONS_ITEMS,
      `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classification_items`,
      callback
    );